export default "__VITE_ASSET__Cne1OYC6__"